import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-arrow-down, download square, save"><path d="M12 7.75V13M14.25 11.25L12 13.5L9.75 11.25M8.75 16.25H15.25M3.75 3.75H20.25V20.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareArrowDown;
